<template>
  <section class="forget-password-content">
    <div class="main">
      <div class="first">
        <div class="email">
          <input type="text" value="" v-model="email" @keypress.enter="submit" placeholder="Email" autocomplete="off"/>
        </div>
        <div class="buttons">
          <div class="error">{{msg}}</div>
          <button class="btn btn-outline-primary" @click="submit" style="margin-right: 30px">{{submit_}}</button>
          <button class="btn btn-outline-primary" @click="reset">{{reset_}}</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapState } from 'vuex'
  import { forgetPwd } from '@/utils/api.js'
  import i18n from '@/i18n'

  export default {
    data () {
      return {
        email: ''
      }
    },
    computed: {
      ...mapState(['v_locale']),
      ...i18n.map([
        'submit_', 'reset_'
      ])
    },
    methods: {
      submit () {
        forgetPwd(this.email, window.location.protocol + '//' + window.location.host)
          .then((data) => {
            this.$emit('msg', {
              msg: data.msg,
              type: 'info',
              delay: 2000,
              callback: () => {
                this.$router.push('/login')
              }
            })
          })
          .catch((err) => {
            this.$emit('msg', {
              msg: err.message,
              type: 'error',
              delay: 2000
            })
          })
      },
      reset () {
        this.email = ''
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/forget_pwd.vue